/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ScholarshipFileApprovalDossierViewModel } from "../types/ScholarshipFileApprovalDossierViewModel.ts";
import { eEnrollmentStatusSchema } from "./eEnrollmentStatusSchema.ts";
import { eScholarshipTypeStudentFileApprovalStatusSchema } from "./eScholarshipTypeStudentFileApprovalStatusSchema.ts";
import { scholarshipFileApprovalStatusOptionViewModelSchema } from "./scholarshipFileApprovalStatusOptionViewModelSchema.ts";
import { scholarshipFileApprovalTypeFileViewModelSchema } from "./scholarshipFileApprovalTypeFileViewModelSchema.ts";

export const scholarshipFileApprovalDossierViewModelSchema = z.object({
  courseFinancialPersonId: z.optional(
    z.number().int().describe("ID do plano financeiro do aluno."),
  ),
  courseRegistrationId: z.optional(
    z.number().int().describe("ID da matrícula do aluno."),
  ),
  personId: z.optional(z.number().int().describe("ID do aluno.")),
  personName: z.string().describe("Nome completo do aluno.").nullish(),
  email: z.string().describe("E-mail do aluno.").nullish(),
  classStudentDescription: z
    .string()
    .describe("Descrição da turma do aluno.")
    .nullish(),
  scholarshipTypeId: z
    .number()
    .int()
    .describe("ID do tipo de bolsa do plano financeiro. Opcional.")
    .nullish(),
  scholarshipTypeName: z
    .string()
    .describe("Descrição do tipo de bolsa.")
    .nullish(),
  enrollmentStatus: z.optional(
    z
      .lazy(() => eEnrollmentStatusSchema)
      .describe(
        "1 = PaymentSelection | 2 = PaymentPending | 3 = ApprovalPending | 4 = Approved | 5 = Activating | 6 = Active | 7 = Transferred | 8 = TransferredInRegistration | 9 = Canceled | 10 = CanceledInRegistration | 11 = Rejected | 12 = FinishedWithPendencies | 13 = Finished | 14 = FinishedWithMonograph | 15 = FinishedWithCertificate | 16 = Blocked | ",
      ),
  ),
  enrollmentStatusName: z
    .string()
    .describe(
      "Descrição do status da matrícula, localizada pela cultura informada na requisição.",
    )
    .nullish(),
  generalStatus: z.optional(
    z
      .lazy(() => eScholarshipTypeStudentFileApprovalStatusSchema)
      .describe(
        "0 = PendingAnswerFromTeam | 1 = Approved | 2 = Rejected | 3 = ApprovedTemporary | ",
      ),
  ),
  filesDeadline: z
    .string()
    .datetime()
    .describe(
      "Data de prorrogação para entrega dos documentos, registrada na matrícula. Opcional.",
    )
    .nullish(),
  statusOptions: z
    .array(z.lazy(() => scholarshipFileApprovalStatusOptionViewModelSchema))
    .describe(
      "Os quatro status gerais possíveis, com o atual marcado. No legado essa marcação era calculada na view.",
    )
    .nullish(),
  typeFiles: z
    .array(z.lazy(() => scholarshipFileApprovalTypeFileViewModelSchema))
    .describe(
      "Tipos de documento ativos exigidos pela bolsa, cada um com os anexos do aluno.",
    )
    .nullish(),
}) as unknown as ToZod<ScholarshipFileApprovalDossierViewModel>;
